
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rooms",
      function () {
        return require("private-next-pages/rooms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rooms"])
      });
    }
  